import xHttp from '@utils/xHttp';
import { getBaseAwsApiUrl, getContentfulApiVersion } from '@utils/config';

// Note: The contentfulCategorySlug should match the category name in Contentful postSubcategory field (the part before the colon).
//      The "-" are replaced by spaces " " in the back end processing before comparing.
const staticCategories = [
  {
    categoryName: 'Home Features',
    categorySlug: '/home-features',
    contentfulCategorySlug: '/home-features',
    categoryKey: 'home-features',
    dpcKey: 'MEY2bhYZZo2tTKgn33fva',
  },
  {
    categoryName: 'Home Buying',
    categorySlug: '/home-buying',
    contentfulCategorySlug: '/home-buying',
    categoryKey: 'home-buying',
    dpcKey: '2G7Jnd4JRvsnf08ZCT3sAD',
  },
  {
    categoryName: 'Home Investment',
    categorySlug: '/home-investment',
    contentfulCategorySlug: '/home-investment',
    categoryKey: 'home-investment',
    dpcKey: '1zlMPf6kRRaMY5c4RU3bPI',
  },
  {
    categoryName: 'Home Building',
    categorySlug: '/manufactured-home-building',
    contentfulCategorySlug: '/home-building',
    categoryKey: 'manufactured-home-building',
    dpcKey: '2x1uFEuWYRZY1yNDMvPgQN',
  },
  {
    categoryName: 'Homeownership',
    categorySlug: '/manufactured-homeownership',
    contentfulCategorySlug: '/homeownership',
    categoryKey: 'manufactured-homeownership',
    dpcKey: 'CcJ9SxJuo5G9VkK3yRLkX',
  },
  {
    categoryName: 'Customer Testimonials',
    categorySlug: '/customer-testimonials',
    contentfulCategorySlug: '/customer-testimonials',
    categoryKey: 'customer-testimonials',
    dpcKey: '2inBjTR8q0wdfd9eWEtxLC',
  },
];

export const getCategories = () => {
  return staticCategories;
};

export const getCurrentCategory = (slug) => {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    const pathSplit = path.split('/').filter((s) => !!s);
    const categorySlug = pathSplit[pathSplit.length - 1];
    return staticCategories.filter(
      (c) => c.categorySlug == '/' + categorySlug
    )[0];
  } else if (slug) {
    return staticCategories.filter((c) => c.categorySlug == '/' + slug)[0];
  }
};

export const getStudioSummary = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/studio/summary`;
  return xHttp.get(url);
};

export const getStudioContent = (slug) => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/studio/content/${slug}`;
  return xHttp.get(url);
};

export const getPageInfo = (dpcKey) => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/contentful/dpc/${dpcKey}`;
  return xHttp.get(url);
};

export const getCuratedCollectionsBrief = () => {
  const url = `${getBaseAwsApiUrl()}${getContentfulApiVersion()}/curated-collections/curated-brief`;
  return xHttp.get(url);
};
